/**
 * Employee Web — `/me/reviews` index route (PERF-06 reviewer experience).
 *
 * Phase 05.1 Plan 07 Task 1. Mounts the `<MyReviewsList>` feature card grid
 * for the authenticated reviewer. Backend gates per-row visibility by
 * assignment — no per-route role filter needed in the loader. This previously
 * named `appraisal:review:read:assigned` as the permission; no such code exists
 * in the backend catalogue, so the name is dropped rather than replaced with a
 * guess.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { MyReviewsList } from "@linkhr/employee-self-service";

export const Route = createFileRoute("/_auth/me/reviews/")({
  staticData: { breadcrumb: { labelKey: "appraisal:reviews.title" } },
  component: MyReviewsRoute,
});

function MyReviewsRoute(): JSX.Element {
  return <MyReviewsList />;
}
